<div class="container">
  <div class="row justify-content-center">
    <div class="col-12 col-md-7 col-lg-5">
      <h1 class="mb-3">Reset password</h1>
      <form class="card" [formGroup]="form" (ngSubmit)="submit()" novalidate>
        <div class="card-body">
          <label class="form-label" for="username">Username</label>
          <input
            id="username"
            type="email"
            class="form-control"
            formControlName="username"
            [class.is-invalid]="form.controls.username.invalid"
            autocomplete="username"
          />
          @if (form.controls.username.hasError('required')) {
            <div class="invalid-feedback d-block" i18n="@@insertUsername">Insert username.</div>
          } @else if (form.controls.username.hasError('email')) {
            <div class="invalid-feedback d-block" i18n="@@invalidEmail">Invalid email format.</div>
          }
          @if (success()) {
            <div class="alert alert-success mt-3" i18n="@@resetPasswordEmailSent">
              If the username exists, you will receive an email with instructions to reset your password.
            </div>
          }
          @if (error()) {
            <div class="alert alert-danger mt-3" i18n="@@resetPasswordError">An error occurred. Please try again later.</div>
          }
        </div>
        <div class="card-footer d-flex justify-content-end">
          <button class="btn btn-primary" type="submit" [disabled]="form.invalid || submitting()">
            <span [class.throb]="submitting()" i18n="@@submit">Submit</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
